import { IColumn } from "OfficeFabric/DetailsList";
import { Action } from "VSS/Flux/Action";
import * as AttachmentOM from "TestManagement/Scripts/Scenarios/LogStore/TestAttachmentModel";
import * as TCMContracts from "TFS/TestManagement/Contracts";

export interface IAttachmentDetails {
    id: number;
    name: string;
    size: number;
    creationDate: Date;
    comment: string;
    url: string;
}

export class AttachmentsGridViewActionsHub {
    public onError = new Action<string>();
    public onErrorMessageClose = new Action<void>();
    public attachmentsLoaded = new Action<AttachmentOM.TestAttachmentModel>();
    public initializeSelection = new Action<void>();
    public initializeColumns = new Action<IColumn[]>();
    public initializeColumnsForLogStore = new Action<IColumn[]>();
    public dismissContextMenu = new Action<IColumn[]>();
    public afterAttachmentDeleted = new Action<TCMContracts.TestAttachment[]>();
    public updateContextMenuOpenIndex = new Action<number>();
    public afterSort = new Action<TCMContracts.TestAttachment[]>();
    public afterSortLogStore = new Action<TCMContracts.TestLog[]>();
    public clearState = new Action<void>();
}